<script setup lang="ts">
/**
 * Group table cell: performers (teachers) linked to the group, one per
 * line, colored by gender — matches `PerformerStatCell`'s established
 * `--color-gender-men`/`--color-gender-women` convention. Mirrors the
 * sketch's `.perfs`/`.perf`.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  /** Resolved performer display rows; empty means "none assigned". */
  performers: { id: string; name: string; gender: 'm' | 'f' | string }[]
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()

const { t } = useI18n()
</script>

<template>
  <td
    class="font-tufte-sans"
    :style="{
      fontSize: 'var(--text-tufte-xs)',
      ...(maxWidth ? { maxWidth, overflowWrap: 'break-word' } : {}),
    }"
  >
    <div v-if="performers.length" class="group-performers-cell__list">
      <span
        v-for="p in performers"
        :key="p.id"
        class="group-performers-cell__name"
        :class="
          p.gender === 'm' ? 'group-performers-cell__name--m' : 'group-performers-cell__name--f'
        "
      >
        {{ p.name }}
      </span>
    </div>
    <span v-else class="group-performers-cell__none text-tufte-muted">{{
      t('cards.group.performersNotSet')
    }}</span>
  </td>
</template>

<style scoped>
.group-performers-cell__list {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.group-performers-cell__name--m {
  color: var(--color-gender-men);
}

.group-performers-cell__name--f {
  color: var(--color-gender-women);
}

.group-performers-cell__none {
  font-style: italic;
}
</style>
